export const timeToSec = (time: string) => {
  const hms = time;
  const timeParts = hms.split(':');
  const calculatedSeconds = +timeParts[0] * 60 * 60 + +timeParts[1] * 60 + +timeParts[2];

  return calculatedSeconds;
};
